/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'icomoo/344-crop': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<path pid="0" d="M13 4l3-3-1-1-3 3H5V0H3v3H0v2h3v8h8v3h2v-3h3v-2h-3V4zM5 5h5l-5 5V5zm1 6l5-5v5H6z"/>'
  }
})
